import Vue from 'vue';
import VTooltip from 'v-tooltip';
import Toasted from 'vue-toasted';
import VueLazyLoad from 'vue-lazyload';
import PortalVue from 'portal-vue';
import VueClipboard from 'vue-clipboard2';
import VueTextareaAutosize from 'vue-textarea-autosize';
import VueObserveVisibility from 'vue-observe-visibility';

import {
  toCurrency,
  toPercentage,
  toNumber,
  toDecimal,
  toDate,
  toDateTime,
  toDuration,
} from '@cardladder/shared/utils/format.util';

import AddLink from '@cardladder/shared/components/AddLink';
import Align from '@cardladder/shared/components/Align';
import Avatar from '@cardladder/shared/components/Avatar';
import Badge from '@cardladder/shared/components/Badge';
import Btn from '@cardladder/shared/components/Btn';
import ButtonDropdown from '@cardladder/shared/components/ButtonDropdown';
import Checkbox from '@cardladder/shared/components/Checkbox';
import Collapse from '@cardladder/shared/components/Collapse';
import CountdownTimer from '@cardladder/shared/components/CountdownTimer';
import DateInput from '@cardladder/shared/components/DateInput';
import Dropdown from '@cardladder/shared/components/Dropdown';
import DropdownMenu from '@cardladder/shared/components/DropdownMenu';
import EmptyState from '@cardladder/shared/components/EmptyState';
import ExternalLink from '@cardladder/shared/components/ExternalLink';
import Graph from '@cardladder/shared/components/Graph';
import HelperText from '@cardladder/shared/components/HelperText';
import Icon from '@cardladder/shared/components/Icon';
import IconButton from '@cardladder/shared/components/IconButton';
import IconLink from '@cardladder/shared/components/IconLink';
import InfiniteScroll from '@cardladder/shared/components/InfiniteScroll';
import LinkableItem from '@cardladder/shared/components/LinkableItem';
import Modal from '@cardladder/shared/components/Modal';
import Multiselect from '@cardladder/shared/components/Multiselect';
import TagInput from '@cardladder/shared/components/TagInput';
import PasswordInput from '@cardladder/shared/components/PasswordInput';
import Pill from '@cardladder/shared/components/Pill';
import PillDropdown from '@cardladder/shared/components/PillDropdown';
import ScrollTop from '@cardladder/shared/components/ScrollTop';
import SelectInput from '@cardladder/shared/components/SelectInput';
import Spinner from '@cardladder/shared/components/Spinner';
import Tab from '@cardladder/shared/components/Tab';
import TextAreaInput from '@cardladder/shared/components/TextAreaInput';
import TextInput from '@cardladder/shared/components/TextInput';
import SearchArea from '@cardladder/shared/components/SearchArea';

import CtaCard from './CtaCard';
import CurrencyInput from './CurrencyInput';
import FtuBlock from './FtuBlock';
import ImageUpload from './ImageUpload';
import LineSeparator from './LineSeparator';
import PageHeader from './PageHeader';
import PanelView from './PanelView';
import SavedFilters from './SavedFilters';
import SavedOptionsDropdown from './SavedOptionsDropdown';

Vue.component('AddLink', AddLink);
Vue.component('Align', Align);
Vue.component('Avatar', Avatar);
Vue.component('Badge', Badge);
Vue.component('Btn', Btn);
Vue.component('ButtonDropdown', ButtonDropdown);
Vue.component('Checkbox', Checkbox);
Vue.component('Collapse', Collapse);
Vue.component('CountdownTimer', CountdownTimer);
Vue.component('CtaCard', CtaCard);
Vue.component('CurrencyInput', CurrencyInput);
Vue.component('DateInput', DateInput);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('EmptyState', EmptyState);
Vue.component('ExternalLink', ExternalLink);
Vue.component('FtuBlock', FtuBlock);
Vue.component('Graph', Graph);
Vue.component('HelperText', HelperText);
Vue.component('Icon', Icon);
Vue.component('IconButton', IconButton);
Vue.component('IconLink', IconLink);
Vue.component('ImageUpload', ImageUpload);
Vue.component('InfiniteScroll', InfiniteScroll);
Vue.component('LineSeparator', LineSeparator);
Vue.component('LinkableItem', LinkableItem);
Vue.component('Modal', Modal);
Vue.component('Multiselect', Multiselect);
Vue.component('TagInput', TagInput);
Vue.component('PageHeader', PageHeader);
Vue.component('PanelView', PanelView);
Vue.component('PasswordInput', PasswordInput);
Vue.component('Pill', Pill);
Vue.component('PillDropdown', PillDropdown);
Vue.component('SavedFilters', SavedFilters);
Vue.component('SavedOptionsDropdown', SavedOptionsDropdown);
Vue.component('ScrollTop', ScrollTop);
Vue.component('SelectInput', SelectInput);
Vue.component('Spinner', Spinner);
Vue.component('Tab', Tab);
Vue.component('TextInput', TextInput);
Vue.component('TextAreaInput', TextAreaInput);
Vue.component('SearchArea', SearchArea);

Vue.use(VTooltip);
Vue.use(VueLazyLoad);
Vue.use(PortalVue);
Vue.use(VueClipboard);
Vue.use(VueTextareaAutosize);
Vue.use(VueObserveVisibility);
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 5000,
  className: 'toasted',
});

Vue.prototype.$filters = {
  currency(value, options) {
    return toCurrency(value, options);
  },

  percentage(value, options) {
    return toPercentage(value, options);
  },

  number(value, options) {
    return toNumber(value, options);
  },

  decimal(value, options) {
    return toDecimal(value, options);
  },

  date(value) {
    return toDate(value);
  },

  datetime(value) {
    return toDateTime(value);
  },

  duration(value) {
    return toDuration(value);
  },
};

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});
